import { SurveyExtensionPoint } from '@seaters/constants';
import { Button } from '@seaters/ui';
import Carousel, { CarouselRef } from 'antd/es/carousel';
import { useEffect, useRef, useState, type JSX } from 'react';
import { LeftOutlined, RightOutlined } from '@ant-design/icons';
import styles from './carousel.module.css';
import { useTranslation } from 'react-i18next';

interface CustomCarouselProps {
  children: JSX.Element[];
  ticketsAmount: number;
  surveyType: SurveyExtensionPoint;
}

export const CustomCarousel = ({
  children,
  ticketsAmount,
  surveyType,
}: CustomCarouselProps) => {
  const { t } = useTranslation();
  const carouselRef = useRef<CarouselRef>(null);

  const [structuredNumber, setStructuredNumber] = useState(1);

  const isFirstStep = structuredNumber === 1;
  const isLastStep = structuredNumber === ticketsAmount;
  const isNavigationSurveyType = [
    SurveyExtensionPoint.AT_CHECKOUT,
    SurveyExtensionPoint.BEFORE_PAYMENT,
    SurveyExtensionPoint.BEFORE_JOINING_WAITINGLIST,
  ].includes(surveyType);

  const handlePrev = () => {
    if (carouselRef.current) {
      carouselRef.current.prev();
      setStructuredNumber(structuredNumber - 1);
    }
  };

  const handleNext = () => {
    if (carouselRef.current) {
      carouselRef.current.next();
      setStructuredNumber(structuredNumber + 1);
    }
  };

  useEffect(() => {
    return () => {
      if (carouselRef.current) {
        carouselRef.current.goTo(0);
      }
    };
  }, []);

  return (
    <>
      <Carousel ref={carouselRef}>{children}</Carousel>
      {isNavigationSurveyType && ticketsAmount > 1 && (
        <div className={styles.carouselControls}>
          <Button
            size="small"
            type="primary"
            icon={<LeftOutlined />}
            onClick={handlePrev}
            style={{ visibility: isFirstStep ? 'hidden' : 'visible' }}
            disabled={isFirstStep}
          >
            {t('prev_btn_text')}
          </Button>

          <Button
            size="small"
            type="primary"
            icon={<RightOutlined />}
            onClick={handleNext}
            style={{ visibility: isLastStep ? 'hidden' : 'visible' }}
            disabled={isLastStep}
          >
            {t('button_text_next')}
          </Button>
        </div>
      )}
    </>
  );
};
